<template>
    <el-button type="success" size="small" circle>
        <ComTooltip content="Hae">
            <el-icon>
                <Search/>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script setup lang="ts">
import { Search } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"
</script>
